module.exports = __webpack_public_path__ + "static/media/semihandmade.f8eba02f.png";